<template>
  <div class="preview-bar" data-external="preview-bar">
    <FriedIcon icon="view" class="preview-icon" />
    {{ $t('preview') }}
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({});
</script>

<style lang="scss" scoped>
.preview-bar {
  position: fixed;
  top: 0;
  left: 0;
  height: 2rem;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  text-align: center;
  align-items: center;
  z-index: $z3;
  background: var(--gray-89);

  .preview-icon {
    height: 1.5rem;
    width: 1.5rem;
    font-weight: bold;
    margin-right: var(--spacing-50);
  }
}
</style>
